import SelectFieldPlaceholder from '@/components/SelectFieldPlaceholder';
import WorldLabel from './WorldLabel';
import { Select, type SelectProps } from '@mui/material';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';
import React from 'react';
import { type AgoraWorld } from '../worlds';
import styled from '@emotion/styled';

type WorldSelectFieldProps = Omit<
  SelectProps<AgoraWorld[]>,
  | 'variant'
  | 'placeholder'
  | 'disabled'
  | 'renderValue'
  | 'style'
  | 'displayEmpty'
  | 'multiple'
> & {
  placeholder: React.ReactNode;
  disabled: boolean;
};

const StyledSelect = styled(Select as typeof Select<AgoraWorld[]>)({
  marginBottom: 12,
  width: 320,
  maxWidth: '100%',
});

function WorldSelectField({
  placeholder,
  disabled,
  ...props
}: WorldSelectFieldProps) {
  const renderSelectedWorldsOrPlaceholder = (
    selectedWorlds: AgoraWorld[],
  ): React.ReactNode => {
    if (selectedWorlds.length === 0) {
      return <SelectFieldPlaceholder>{placeholder}</SelectFieldPlaceholder>;
    }

    return selectedWorlds.map(world => (
      <WorldLabel world={world} key={world} />
    ));
  };

  const portfolioIsReadonly = useIsPortfolioReadonly();

  return (
    <StyledSelect
      variant="standard"
      disabled={portfolioIsReadonly || disabled}
      renderValue={renderSelectedWorldsOrPlaceholder}
      displayEmpty
      multiple
      {...props}
    />
  );
}

export default WorldSelectField;
